// extracted by mini-css-extract-plugin
export default {"tracking_status":"ParcelStatusInfo_tracking_status__yqgEj"};